import React from 'react';
import PropTypes from 'prop-types';
import SubmissionFooter from 'screens/Integrations/components/SubmissionFooter';
import { INTEGRATIONS } from 'screens/Integrations/helpers/constants';
import { AgrianContext } from '../../context/Provider';

const agrianSubmissionFooterDefaultPropOnNext = () => {};
const agrianSubmissionFooterDefaultPropSetModalSubmissionState = () => {};
const AgrianSubmissionFooter = ({
  nextDisabled = false,
  onNext = agrianSubmissionFooterDefaultPropOnNext,
  nextLabel = 'Next',
  setModalSubmissionState = agrianSubmissionFooterDefaultPropSetModalSubmissionState,
  isLastStep = false,
  integrationType = INTEGRATIONS.agrian,
  isBottomFixed = false,
  displaySubmissionModal = true
}) => {
  return (
    <SubmissionFooter
      nextDisabled={nextDisabled}
      onNext={onNext}
      setModalSubmissionState={setModalSubmissionState}
      isLastStep={isLastStep}
      context={AgrianContext}
      nextLabel={nextLabel}
      integrationType={integrationType}
      isBottomFixed={isBottomFixed}
      displaySubmissionModal={displaySubmissionModal}
    />
  );
};

AgrianSubmissionFooter.propTypes = {
  nextDisabled: PropTypes.bool,
  onNext: PropTypes.func,
  setModalSubmissionState: PropTypes.func,
  isLastStep: PropTypes.bool,
  integrationType: PropTypes.string,
  nextLabel: PropTypes.string,
  isBottomFixed: PropTypes.bool,
  displaySubmissionModal: PropTypes.bool
};

export default AgrianSubmissionFooter;
